/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAdditionalInsuredDto } from './CreateAdditionalInsuredDto';
import type { CreateAddressDto } from './CreateAddressDto';
import type { CreateMainContactDto } from './CreateMainContactDto';
export type CreateClientDto = {
    /**
     * Title (MR, MRS, MS, DOCTOR, etc. — uppercase Ando values)
     */
    title?: string;
    /**
     * First name (for INDIVIDUAL clients) or business name (for BUSINESS clients)
     */
    firstName: string;
    /**
     * Last name (for INDIVIDUAL clients). For BUSINESS clients, this can be empty.
     */
    lastName: string;
    /**
     * Date of birth (for INDIVIDUAL clients)
     */
    dob?: string;
    /**
     * Gender (for INDIVIDUAL clients)
     */
    gender?: CreateClientDto.gender;
    /**
     * Type of client
     */
    clientType: CreateClientDto.clientType;
    /**
     * Primary phone number
     */
    phone: string;
    /**
     * Primary email address
     */
    email: string;
    /**
     * When true, allows creating a client even if another client of the same type already uses this email. Requires explicit user confirmation in the UI.
     */
    allowDuplicateEmail?: boolean;
    /**
     * UUID of the assigned adviser
     */
    assignedAdviserId?: string;
    /**
     * Company registration number (for BUSINESS clients)
     */
    companyRegNo?: string;
    /**
     * Trading as name (for BUSINESS clients)
     */
    tradingAs?: string;
    /**
     * GST number (for BUSINESS clients)
     */
    gstNumber?: string;
    /**
     * Flag indicating if client is vulnerable
     */
    isVulnerable?: boolean;
    /**
     * Flag indicating if client has policies with other providers
     */
    hasMultiplePolicies?: boolean;
    /**
     * Flag indicating if client is an employee
     */
    isEmployee?: boolean;
    /**
     * Additional notes about the client
     */
    notes?: string;
    /**
     * Main contact details (only for BUSINESS clients)
     */
    mainContact?: CreateMainContactDto;
    /**
     * List of addresses for the client. At least one correspondence address is required.
     */
    addresses: Array<CreateAddressDto>;
    /**
     * List of additional insured persons
     */
    additionalInsureds?: Array<CreateAdditionalInsuredDto>;
};
export namespace CreateClientDto {
    /**
     * Gender (for INDIVIDUAL clients)
     */
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        OTHER = 'OTHER',
    }
    /**
     * Type of client
     */
    export enum clientType {
        INDIVIDUAL = 'INDIVIDUAL',
        BUSINESS = 'BUSINESS',
    }
}

